import { createApp } from 'utils/vue';
import App from "components/pages/entries/create";
import { registerHandler } from "utils/handler";

const handler = (app) => {
  createApp(App).mount("#app-container");
};

registerHandler("entries/create", handler);
